import Details from "../components/AuctionListing/Details";
import Icon from "../components/AuctionListing/Icon";
import Image from "../components/AuctionListing/Image";
import MapLocation from "../components/AuctionListing/MapLocation";
import SellerDescription from "../components/AuctionListing/SellerDescription";
import Offer from "../components/BuyListing/Offer";
import Add from "../components/ClassifiedAdListingDisplay/Add";
import Container from "../components/layout/Container";
import MoreItems from "../components/Shared/MoreItems/MoreItems";
import { products } from "../data/products";

const BuyListingCustomDisplay = () => {
  return (
    <Container>
        <Icon />
        <div className="flex items-start justify-between">
          <div>
            <Image />
            <Details />
          </div>
          <div>
            <Offer />
            <SellerDescription />
            <MapLocation />
          </div>
        </div>
        <MoreItems products={products} title="MORE ITEMS FROM THIS SELLER" />
        <MoreItems products={products} title="SIMILAR ITEMS" />
        <Add />
      </Container>
  )
}

export default BuyListingCustomDisplay